import * as React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { Wrapper } from './tabbed-header.styled';

const SkeletonWrapper = styled(Wrapper)`
  padding: 0.5rem;
  & > * {
    margin-right: 1rem;
  }
`;

export const TabbedHeaderSkeleton = () => {
  return (
    <SkeletonWrapper>
      <Skeleton height="95%" width="5rem" />
      <Skeleton height="95%" width="5rem" />
      <Skeleton height="95%" width="5rem" />
      <Skeleton height="95%" width="5rem" />
    </SkeletonWrapper>
  );
};
